import { render } from "./kebab-small.svg?vue&type=template&id=c70fbb4e"
const script = {}
script.render = render

export default script